<template>
  <div>
    <Button
      size="default"
      type="primary"
      style="margin-bottom: 10px"
      @click="onPrint"
      >打印</Button
    >
    <Table border :columns="columns1" :data="data1"></Table>
    <br />
    <Page
      :total="total"
      show-total
      @on-change="changePage"
      @on-page-size-change="changePagesize"
    />
    <Modal title="图片预览" v-model="imgVisible">
      <img :src="loadimg(imgUrl)" style="width: 100%" />
    </Modal>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
import { Button } from "view-design";
export default {
  props: {
    inventoryId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      columns1: [
        {
          title: "抄表人",
          width: 100,
          key: "createBy",
          align: "center",
        },
        {
          title: "抄表时间",
          width: 180,
          key: "createTime",
          align: "center",
        },
        {
          title: "抄表数量",
          minWidth: 80,
          key: "readingAmount",
          align: "center",
          render: (h, params) => {
            console.log(params);
            let rows = params.row;
            return rows.readingDetails.map((item) => {
              return (
                <div>
                  {item.typeName}：{item.currentCount}
                </div>
              );
            });
            // return (
            //   // <div style="width:100px;">
            //     // <div>A4 黑白：</div>
            //     // <div>A4 彩色：</div>
            //     // <div>A3 黑白：</div>
            //     // <div>A3 彩色：</div>
            //   // </div>
            // );
          },
        },
        {
          title: "抄张图片",
          key: "operatorImg",
          width: 140,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const vm = this;
            const src = row.operatorImg
              ? row.operatorImg.includes("http")
                ? row.operatorImg
                : IMAGE_HOST + row.operatorImg
              : "";
            return h("img", {
              domProps: {
                src: src,
              },
              style: {
                margin: "5px auto",
                width: "auto",
                height: "20px",
              },
              on: {
                click: () => {
                  vm.imgUrl = src;
                  vm.imgVisible = true;
                },
              },
            });
            // return (
            //   <div style="width:100px;height:100px;">
            //     <img src={text} />
            //   </div>
            // );
          },
        },
        {
          title: "本期计数",
          minWidth: 80,
          key: "readingAmount",
          align: "center",
          render: (h, params) => {
            let rows = params.row;
            return rows.readingDetails.map((item) => {
              return (
                <div>
                  {item.typeName}：{item.difference}
                </div>
              );
            });
            // return (
            //   <div style="width:100px;">
            //     <div>A4 黑白：</div>
            //     <div>A4 彩色：</div>
            //     <div>A3 黑白：</div>
            //     <div>A3 彩色：</div>
            //   </div>
            // );
          },
        },
      ],
      data1: [],
      total: this.total,
      imgVisible: false,
    };
  },
  created() {
    // let query = this.$route && this.$route.query;
    // if ((query && query.inventoryId) || this.inventoryId) {
    //   // 设置查询参数
    //   this.query.inventoryId = (query && query.inventoryId) || this.inventoryId;
    // }
  },
  mounted() {
    if (this.inventoryId) {
      this.load(this.inventoryId);
    }
  },
  methods: {
    onPrint() {
      //   let q = this.query;
      //   let customerNameStr =
      //     Number(customerId) === 0
      //       ? window.localStorage.getItem("customerNameClick")
      //       : window.localStorage.getItem("customerName");
      let q = {};
      let customerNameStr = window.localStorage.getItem("customerName");
      $utils.api
        .load(
          `/admin/system/sysFacilityMeterReading/getListByFacilityId/${this.inventoryId}`,
          q,
          "get"
        )
        .then((res) => {
          let list = [];
          res.rows.forEach((item, index) => {
            let obj = {
              createBy: item.createBy,
              createTime: item.createTime,
              readingAmount: item.readingDetails.map((item) => {
                return `${item.typeName + "：" + item.currentCount}<br/>`;
              }),
              readingAmountNew: item.readingDetails.map((item) => {
                return `${item.typeName + "：" + item.difference}<br/>`;
              }),
            };
            list.push(obj);
          });
          console.log(list);

          let properties = [
            { field: "createBy", displayName: "抄表人" },
            { field: "createTime", displayName: "抄表时间" },
            { field: "readingAmount", displayName: "抄表数量" },
            { field: "readingAmountNew", displayName: "本期计数" },
          ];
          printJS({
            printable: list,
            properties: properties,
            header: customerNameStr + "抄张记录表",
            headerStyle: `
                      font-weight:800;
                      font-size:18px;
                      text-align: center;
                      `,
            gridHeaderStyle: "border:none;",
            gridStyle: "border:none",
            style: `
                          th{
                          font-size:14px;
                          border-bottom: 1px solid #999 !important;
                          padding: 10px 0;
                          }
                          td{
                          font-size:14px;
                          border-bottom: 1px solid #999 !important;
                          padding: 10px 0;
                          text-align:center;
                          }
                          `,
            type: "json",
          });
        });
    },
    loadimg(url, type = "image") {
      return $utils.image.load(url, type);
    },
    load(inventoryId, page = 1) {
      let q = {};
      // let a = {}
      // a.inventoryId = inventoryId
      // q.inventoryId = inventoryId;
      // q.page = page
      q.pageSize = 10;
      q.pageNum = page;
      q.orderByColumn = "createTime";
      q.isAsc = "descending";
      $utils.api
        .load(
          `/admin/system/sysFacilityMeterReading/getListByFacilityId/${inventoryId}`,
          q,
          "get"
        )
        .then((res) => {
          if (res.code == 200) {
            let data = res.rows;
            let list = data || [];
            this.data1 = list;
            this.total = res.total;
          }
        })
        .catch(() => {
          $utils.toast.error("请求错误");
        });
    },
    changePage(p) {
      this.load(this.inventoryId, p);
    },
    changePagesize(psize) {},
  },
};
</script>
